/**
 * Created by jonas on 2020-08-13.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class LonerGameMode extends GameMode {
    public static readonly FEATURE_SHOOT_SHOOT_DUCK:string = "FEATURE_SHOOT_SHOOT_DUCK";
    public static readonly FEATURE_TICK_TICK_BOOM:string = "FEATURE_TICK_TICK_BOOM";
    public static readonly FEATURE_PIN_THE_WIN:string = "FEATURE_PIN_THE_WIN";
    public static readonly NORMAL:string = "NORMAL";
    public static readonly BACK_FROM_PTW:string = "BACK_FROM_PTW";
    public static readonly BACK_FROM_SSD:string = "BACK_FROM_SSD";
    public static readonly BACK_FROM_TTB:string = "BACK_FROM_TTB";
    public static readonly MAX_WIN:string = "MAX_WIN";
    public static readonly ENDLESS_IDLE:string = "ENDLESS_IDLE";
}